import React from "react";
import { XIcon } from "@/components/parts/Icon";
import { trackAction } from "@/lib/Analytics";
import { openUserbackForm } from "@/lib/Userback";
import { buildXShareUrl } from "@/lib/XShare";

export interface ArticleEndActionsProps {
  slug: string;
  title: string;
  url: string;
}

export const ArticleEndActions: React.FC<ArticleEndActionsProps> = ({
  slug,
  title,
  url,
}) => {
  const handleReportClick = () => {
    trackAction("nekometry_article_report_open", { article_slug: slug });
    void openUserbackForm("bug");
  };

  return (
    <section
      aria-label="記事のシェアと報告"
      className="mt-10 flex flex-col gap-3 border-t border-primary-100 pt-8 sm:flex-row sm:justify-center"
    >
      <a
        href={buildXShareUrl({ text: `${title} | Nekometry`, url })}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackAction("nekometry_x_share", { article_slug: slug })}
        className="inline-flex items-center justify-center gap-2 rounded-full border border-gray-900 bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-gray-700"
      >
        <XIcon />
        Xでシェアする
      </a>
      <button
        type="button"
        onClick={handleReportClick}
        className="inline-flex items-center justify-center rounded-full border border-primary-200 bg-white px-5 py-2.5 text-sm font-semibold text-primary-700 shadow-sm transition hover:bg-primary-100"
      >
        気になる点を報告する
      </button>
    </section>
  );
};
